import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "t6_table_c2" }
const _hoisted_2 = { class: "textLeft" }
const _hoisted_3 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { src: "/images/ysc.png" }
const _hoisted_6 = { class: "upload_td" }
const _hoisted_7 = { class: "upload_div" }
const _hoisted_8 = { class: "num" }
const _hoisted_9 = { style: {"min-height":"300px"} }

import { getServiceMaterialList } from "@/config/request";
import { ElMessage } from "element-plus";
import { nextTick, reactive, ref, toRefs } from "vue";
import { UploadFilled } from '@element-plus/icons-vue'
import Nav from "./nav.vue";
import { AREA_ID,FILE_URL } from "@/config/const";
import type { UploadProps, UploadUserFile } from 'element-plus'


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    publicData: Object
},
  setup(__props, { expose: __expose }) {

const props = __props
let fileUrl = ref(FILE_URL)
console.log('fileUrl',fileUrl);

let dialogVisible = ref(false)
let matterTitle = ref('')
let currentPreAttrFiles = ref([]) as any
let currentUnid = ref('')
const showDialog = (item:any) => {
    currentPreAttrFiles.value = []
    console.log('item',item);
    let name = `上传【${item.attrname}】的附件`
    matterTitle.value = name
    currentPreAttrFiles.value = item.preAttrFiles2
    currentUnid.value = item.unid
    setTimeout(()=>{
        dialogVisible.value = true
    },100)
}
const closeDialog = () => {
    console.log('关闭');
    currentPreAttrFiles.value = []
    currentUnid.value = ''
    matterTitle.value = ''
}
const { publicData } = toRefs(props) as any

const handleSuccess:UploadProps['onSuccess'] = (response,file,files) => {
    console.log('onSuccess-response',response);
    let fileId = ''
    if(response.code === 0){
        ElMessage.success('上传成功')
        fileId = response.fileId
    }else{
        ElMessage.error('上传失败')
    }
    console.log('onSuccess-file',file);
    console.log('onSuccess-files',files);
    console.log('onSuccess---basicInfo.preAttrs',publicData.value.basicInfo.preAttrs);
    console.log('currentPreAttrFiles',currentPreAttrFiles.value);
    let preAttrs = publicData.value.basicInfo.preAttrs
    for(let i = 0; i < preAttrs.length; i++){
        let preAttr = preAttrs[i]

        if(currentUnid.value === preAttr.unid){
            preAttr.preAttrFiles2 = currentPreAttrFiles.value
        }
    }
    console.log('onSuccess2---basicInfo.preAttrs',publicData.value.basicInfo.preAttrs);

}

const uuid = () => {
    let s = [] as any
    let hexDigits = '0123456789abcdef'
    for (let i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
    }
    s[14] = '4'
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)
    s[8] = s[13] = s[18] = s[23] = '-'

    let uuid = s.join('')
    return uuid
}

const check = () => {
    let status = 200    //  返回状态
    let preAttrs = publicData.value.basicInfo.preAttrs
    const attrsLength = preAttrs.length
    for(let i = 0; i < attrsLength; i++){

    }
    preAttrs.forEach((res:any) => {
        if('Y' === res.importLevel && res.preAttrFiles2.length > 0){
            console.log('必要的上传了');
        }else{
            console.log('有必须上传的材料没有上传');
            status = 500
        }
    });
    if(status === 200){
        preAttrs.forEach((res:any) => {
            const preAttrFiles2 = res.preAttrFiles2
            const length2 = preAttrFiles2.length
            if(length2 > 0){
                for(let j = 0; j < length2; j++){
                    let file = {} as any
                    file['attrUnid'] = res.unid
                    file['fileName'] = preAttrFiles2[j].name
                    file['fileUnid'] = JSON.parse(preAttrFiles2[j].response.result).fileId
                    file['fileUrl'] = ''
                    file['unid'] = uuid()
                    res.preOnethingAttrFileList.push(file)
                }
            }
        });
    }else{
        ElMessage.error('有必传的材料未上传')
    }


    let result = {
        data: publicData.value,
        status: status
    }

    return result
}

__expose({
    check
})


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Nav),
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "t6_title_h2" }, "申请材料", -1)),
    _createElementVNode("table", _hoisted_1, [
      _cache[2] || (_cache[2] = _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", { width: "100" }, "序号"),
          _createElementVNode("th", null, "申请材料"),
          _createElementVNode("th", { width: "150" }, "是否必要"),
          _createElementVNode("th", { width: "150" }, "是否上传"),
          _createElementVNode("th", { width: "150" }, "操作")
        ])
      ], -1)),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(publicData).basicInfo.preAttrs, (item, i) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: item.id
          }, [
            _createElementVNode("td", null, _toDisplayString(i+1), 1),
            _createElementVNode("td", _hoisted_2, _toDisplayString(item.attrname), 1),
            _createElementVNode("td", null, [
              (item.importLevel == 'Y')
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, "必要"))
                : _createCommentVNode("", true),
              (item.importLevel == 'N')
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, "非必要"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("td", null, [
              _withDirectives(_createElementVNode("img", _hoisted_5, null, 512), [
                [_vShow, item.preAttrFiles2.length > 0]
              ])
            ]),
            _createElementVNode("td", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", null, [
                  _createVNode(_unref(UploadFilled), {
                    class: "upload_icon",
                    onClick: ($event: any) => (showDialog(item))
                  }, null, 8, ["onClick"])
                ]),
                _createElementVNode("span", _hoisted_8, _toDisplayString(item.preAttrFiles2.length), 1)
              ])
            ])
          ]))
        }), 128))
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _unref(dialogVisible),
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(dialogVisible) ? (dialogVisible).value = $event : dialogVisible = $event)),
      title: _unref(matterTitle),
      width: "800px",
      onClose: closeDialog
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_el_upload, {
            class: "upload-demo",
            "file-list": _unref(currentPreAttrFiles),
            "onUpdate:fileList": _cache[0] || (_cache[0] = ($event: any) => (_isRef(currentPreAttrFiles) ? (currentPreAttrFiles).value = $event : currentPreAttrFiles = $event)),
            action: _unref(fileUrl),
            multiple: "",
            "on-change": _ctx.handleChange,
            "on-success": handleSuccess
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_el_button, { type: "primary" }, {
                  default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                    _createTextVNode("上传", -1)
                  ]))]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["file-list", "action", "on-change"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}
}

})